'use strict'

const initMod2KeyboardShortcutsUi = function ({
  _ = window._,
  $ = window.jQuery,
  $body = ($ ? $('body') : null),
  shortcutDefsRaw = [],
  parseShortcut = function () { return null },
  isTypingContext = function () { return false },
  normalizeEventKey = function () { return '' },
  eventMatchesShortcut = function () { return false },
  fnDeactivateMod2Modes = function () { return false }
} = {}) {
  if (!_ || !$ || !$body) return

  if ($body.data('mod2KeyboardInit')) return
  $body.data('mod2KeyboardInit', true)

  const shortcutDefs = shortcutDefsRaw
    .map(function (item) {
      return _.assign({}, item, { parsed: parseShortcut(item && item.shortcut) })
    })
    .filter(function (item) { return item && item.selector && item.parsed })

  $(document).on('keydown', function (event) {
    if (isTypingContext(event.target)) return

    if (normalizeEventKey(event) === 'ESCAPE') {
      if (fnDeactivateMod2Modes()) {
        event.preventDefault()
      }
      return
    }

    for (let i = 0; i < shortcutDefs.length; i++) {
      const def = shortcutDefs[i]
      if (!eventMatchesShortcut(event, def.parsed)) continue
      const $btn = $body.find(def.selector).filter('.btn-portal--mod2:visible').first()
      if (!$btn.length || $btn.prop('disabled')) return
      $btn.trigger('click')
      event.preventDefault()
      return
    }
  })
}

const deactivateMod2ModesUi = function ({
  $body,
  fnGetImportAddPointMode = function () { return false },
  fnSetImportAddPointMode = function () {},
  fnGetImportDragMode = function () { return false },
  fnSetImportDragMode = function () {},
  fnGetImportSelectMode = function () { return false },
  fnSetImportSelectMode = function () {},
  fnGetImportSelectDrawPoly = function () { return null },
  fnGetImportSeekMode = function () { return false },
  fnSetImportSeekMode = function () {},
  fnGetImportSeekDrawActive = function () { return false },
  fnSetImportSeekDrawActive = function () {},
  fnSetImportSeekAxisCallback = function () {},
  fnGetImportSeekDrawLine = function () { return null },
  fnSetImportSeekDrawLine = function () {},
  fnGetImportActivePoint = function () { return null },
  fnSetImportActivePoint = function () {},
  fnSyncAddPointCursor = function () {},
  fnSetWaypointDragging = function () {}
} = {}) {
  if (!$body) return false

  let changed = false
  if (fnGetImportAddPointMode()) {
    fnSetImportAddPointMode(false)
    fnSetImportActivePoint(null)
    $body.find('[data-leaf-add-point]').removeClass('active')
    fnSyncAddPointCursor()
    changed = true
  }
  if (fnGetImportDragMode()) {
    fnSetImportDragMode(false)
    fnSetImportActivePoint(null)
    fnSetWaypointDragging(false)
    changed = true
  }
  if (fnGetImportSelectMode()) {
    fnSetImportSelectMode(false)
    $body.find('[data-leaf-select-poly]').removeClass('active')
    const drawPoly = fnGetImportSelectDrawPoly()
    if (drawPoly && typeof drawPoly.disable === 'function') drawPoly.disable()
    changed = true
  }
  if (fnGetImportSeekMode() || fnGetImportSeekDrawActive()) {
    fnSetImportSeekMode(false)
    fnSetImportSeekDrawActive(false)
    fnSetImportSeekAxisCallback(null)
    const drawLine = fnGetImportSeekDrawLine()
    if (drawLine && typeof drawLine.disable === 'function') {
      drawLine.disable()
    }
    fnSetImportSeekDrawLine(null)
    $body.find('[data-leaf-seek]').removeClass('active')
    changed = true
  }
  return changed
}

const initMobileNavbarArrowsUi = function ({
  _ = window._,
  $ = window.jQuery,
  $body = ($ ? $('body') : null)
} = {}) {
  if (!_ || !$ || !$body) return

  const $navbar = $('.portal-navbar').first()
  const $railCont = $('.portal-navbar-rail-cont').first()
  const $rail = $railCont.find('.portal-navbar-rail').first()
  const $left = $body.find('[data-navbar-scroll="left"]')
  const $right = $body.find('[data-navbar-scroll="right"]')
  if (!$navbar.length || !$railCont.length || !$rail.length || !$left.length || !$right.length) return
  if ($railCont.data('mobileArrowsInit')) return
  $railCont.data('mobileArrowsInit', true)

  let offsetX = 0
  const fnGetScrollStep = function () {
    return Math.max(40, Math.round(window.innerWidth - 100))
  }

  const clamp = function (value, min, max) {
    return Math.min(max, Math.max(min, value))
  }

  const fnGetMaxOffset = function () {
    const viewWidth = Math.round($railCont.innerWidth() || 0)
    const railWidth = Math.round($rail.outerWidth() || 0)
    return Math.max(0, railWidth - viewWidth)
  }

  const fnApplyOffset = function () {
    $rail.css('transform', `translateX(${-offsetX}px)`)
    const maxOffset = fnGetMaxOffset()
    const hasOverflow = maxOffset > 0
    $navbar.toggleClass('portal-navbar--paging-active', hasOverflow)
    $left.toggleClass('is-hidden', !hasOverflow || offsetX <= 0)
    $right.toggleClass('is-hidden', !hasOverflow || offsetX >= maxOffset)
  }

  const fnRecalc = function () {
    const maxOffset = fnGetMaxOffset()
    offsetX = clamp(offsetX, 0, maxOffset)
    fnApplyOffset()
  }

  $left.on('click', function () {
    offsetX = clamp(offsetX - fnGetScrollStep(), 0, fnGetMaxOffset())
    fnApplyOffset()
  })

  $right.on('click', function () {
    offsetX = clamp(offsetX + fnGetScrollStep(), 0, fnGetMaxOffset())
    fnApplyOffset()
  })

  const fnRecalcBurst = function () {
    fnRecalc()
    requestAnimationFrame(fnRecalc)
    setTimeout(fnRecalc, 80)
    setTimeout(fnRecalc, 240)
  }

  $(window).on('resize orientationchange', _.throttle(fnRecalc, 120))
  $(window).on('load', fnRecalcBurst)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fnRecalc).catch(function () {})
  }
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(_.throttle(fnRecalc, 80))
    ro.observe($railCont.get(0))
    ro.observe($rail.get(0))
  }
  fnRecalcBurst()
}

export {
  deactivateMod2ModesUi,
  initMod2KeyboardShortcutsUi,
  initMobileNavbarArrowsUi
}
